import { GET, POST } from "../config/axios.config";
import { uploadFiles } from "./upload.api";

/**
 * Live chat with OwnFood Support (`/chat`). Every call names the `channel` —
 * on this site always "customer". Support replies arrive as `from: "support"`
 * with no agent name; that is deliberate on the API's side.
 */

export const getChatThread = async (channel, { before, limit = 30 } = {}) => {
  const res = await GET("/chat", { params: { channel, before, limit } });
  return {
    conversation: res?.data?.conversation ?? null,
    messages: res?.data?.messages ?? [],
    hasMore: !!res?.data?.hasMore,
  };
};

export const sendChatMessage = async (channel, { body = "", attachments = [] }) => {
  const res = await POST("/chat/messages", { channel, body, attachments });
  return {
    conversation: res?.data?.conversation ?? null,
    messages: res?.data?.messages ?? [],
  };
};

export const markChatRead = async (channel) => {
  const res = await POST("/chat/read", { channel });
  return res?.data?.conversation ?? null;
};

/** Uploads picked files and returns the `{ url, name, mime, size }` the chat API stores. */
export const uploadChatFiles = async (files) => {
  const list = Array.from(files || []);
  const urls = await uploadFiles(list);
  return urls.map((url, i) => ({
    url,
    name: list[i]?.name || "file",
    mime: list[i]?.type || "application/octet-stream",
    size: list[i]?.size || 0,
  }));
};
